import { Button, DatePicker, Form, Select, Space } from 'antd';
import React from 'react';
import { ActionHistoryFilterType } from '../types/actionHistoryType';

const { RangePicker } = DatePicker;

interface ActionHistoryFilterProps {
  onFilter: (filters: ActionHistoryFilterType) => void;
  onReset: () => void;
}

const ActionHistoryFilter: React.FC<ActionHistoryFilterProps> = ({ onFilter, onReset }) => {
  const [form] = Form.useForm();

  const actionOptions = [
    { label: 'Create', value: 'create' },
    { label: 'Update', value: 'update' },
    { label: 'Delete', value: 'delete' },
    { label: 'Bulk Update', value: 'bulk_update' },
    { label: 'Bulk Delete', value: 'bulk_delete' },
    { label: 'Distribute', value: 'distribute' },
  ];

  const objectTypeOptions = [
    { label: 'Content', value: 'content' },
    { label: 'Series', value: 'series' },
    { label: 'Season', value: 'season' },
    { label: 'Playlist', value: 'playlist' },
    { label: 'Category', value: 'category' },
    { label: 'People', value: 'people' },
    { label: 'Contract', value: 'contract' },
    { label: 'Company', value: 'company' },
    { label: 'User', value: 'user' },
  ];

  const handleSubmit = (values: any) => {
    const filters: ActionHistoryFilterType = {
      action: values.action,
      object_type: values.object_type,
      start_date: values.date_range?.[0]?.toISOString(),
      end_date: values.date_range?.[1]?.toISOString(),
    };
    onFilter(filters);
  };

  const handleReset = () => {
    form.resetFields();
    onReset();
  };

  return (
    <Form form={form} onFinish={handleSubmit} layout="inline">
      <Form.Item name="action" label="Action">
        <Select placeholder="Action" allowClear style={{ width: 150 }} options={actionOptions} />
      </Form.Item>

      <Form.Item name="object_type" label="Object Type">
        <Select
          placeholder="Object Type"
          allowClear
          style={{ width: 150 }}
          options={objectTypeOptions}
        />
      </Form.Item>

      <Form.Item name="date_range" label="Date Range">
        <RangePicker format="YYYY-MM-DD" placeholder={['Start Date', 'End Date']} />
      </Form.Item>

      <Form.Item>
        <Space>
          <Button type="primary" htmlType="submit">
            Apply
          </Button>
          <Button onClick={handleReset}>Reset</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default ActionHistoryFilter;
